import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWaveRound2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconWaveRound2"><Path d="M2.5 12H4C5.65685 12 7 10.6569 7 9V6C7 4.61929 8.11929 3.5 9.5 3.5C10.8807 3.5 12 4.61929 12 6V18C12 19.3807 13.1193 20.5 14.5 20.5C15.8807 20.5 17 19.3807 17 18V14.5C17 12.8431 18.3431 11.5 20 11.5H21.5" stroke="currentColor" strokeLinecap="square" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconWaveRound2;
